import React from 'react'
import { formatPrice, getFacilityTypeText } from '../../../../../app/core/utils/utility'
import {
  IBoardOfDirector,
  ICheque,
  IFacilityInquiryRealLegalResponseModel,
  IUserDetail,
  IUserProfile,
} from '../../../../../../src/app/core/interfaces'
import moment from 'jalali-moment';

const FacilityPdfExport = ({
  userDetail,
  userProfile,
  backCheques,
  listBoardOfDirector,
  facilityInquiryRealLegalData,
  listBoardOfDirectorFacilities,
}: {
  userDetail: IUserDetail | undefined
  userProfile: IUserProfile | undefined
  backCheques: ICheque[] | undefined
  listBoardOfDirector: IBoardOfDirector[] | undefined
  facilityInquiryRealLegalData:
  | IFacilityInquiryRealLegalResponseModel
  | undefined
  listBoardOfDirectorFacilities: IBoardOfDirector[] | undefined
}) => {

  const listOfFacilities = facilityInquiryRealLegalData?.result?.facilityList;
  const inquiryDate = moment(new Date()).locale('fa').format('jYYYY/jMM/jDD');

  return (
    <div
      style={{
        width: '1000px',
        minHeight: '1123px',
        backgroundColor: 'white',
        margin: '0 auto',
        padding: 0,
        fontWeight: 'bold',
      }}
    >
      <div className=''>
        <div style={{ width: '100%', marginBottom: '3px' }}>
          <div
            style={{
              textAlign: 'center',
              width: '100%',
              backgroundColor: '#A8E0F0',
              padding: '10px',
            }}
          >
            <h2>تسهیلات</h2>
          </div>
          <div style={{ width: '100%', marginTop: '3px' }}>
            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
              <thead>
                {/* Header Row 1 - Main Headers */}
                <tr style={{ backgroundColor: '#F0F0F0', fontWeight: 'bold' }}>
                  <th
                    style={{
                      border: '1px solid #ddd',
                      padding: '10px',
                      textAlign: 'center',
                      width: '10%',
                    }}
                  >
                    <h5>نام</h5>
                  </th>
                  <th
                    style={{
                      border: '1px solid #ddd',
                      padding: '10px',
                      textAlign: 'center',
                      width: '10%',
                    }}
                  >
                    <h5>تاریخ استعلام</h5>
                  </th>
                  <th
                    style={{
                      border: '1px solid #ddd',
                      padding: '10px',
                      textAlign: 'center',
                      width: '10%',
                    }}
                  >
                    <h5>ﻧﻮﻉ ﻗﺮﺍﺭﺩﺍﺩ</h5>
                  </th>
                  <th
                    style={{
                      border: '1px solid #ddd',
                      padding: '10px',
                      textAlign: 'center',
                      width: '14%',
                    }}
                  >
                    <h5>نام بانک</h5>
                  </th>
                  <th
                    style={{
                      border: '1px solid #ddd',
                      padding: '10px',
                      textAlign: 'center',
                      width: '8%',
                    }}
                  >
                    <h5>تاریخ تنظیم</h5>
                  </th>
                  <th
                    style={{
                      border: '1px solid #ddd',
                      padding: '10px',
                      textAlign: 'center',
                      width: '12%',
                    }}
                  >
                    <h5>تاریخ پایان</h5>
                  </th>
                  <th
                    style={{
                      border: '1px solid #ddd',
                      padding: '10px',
                      textAlign: 'center',
                      width: '12%',
                    }}
                  >
                    <h5>مبلغ تسهیلات</h5>
                  </th>
                  <th
                    style={{
                      border: '1px solid #ddd',
                      padding: '10px',
                      textAlign: 'center',
                      width: '12%',
                    }}
                  >
                    <h5>مانده بدهی</h5>
                  </th>
                  <th
                    style={{
                      border: '1px solid #ddd',
                      padding: '10px',
                      textAlign: 'center',
                      width: '12%',
                    }}
                  >
                    <h5>مانده معوقه</h5>
                  </th>
                  <th
                    style={{
                      border: '1px solid #ddd',
                      padding: '10px',
                      textAlign: 'center',
                      width: '12%',
                    }}
                  >
                    <h5>شماره درخواست</h5>
                  </th>
                </tr>
              </thead>
              <tbody>
                {listOfFacilities?.length === 0 ? (
                  <div style={{ margin: '5px' }}>{'چک برگشتی وجود ندارد '}</div>
                ) : (
                  listOfFacilities?.map((item, index) => (
                    <tr key={index}>
                      <td style={{ border: '1px solid #ddd', padding: '10px', textAlign: 'center' }}>
                        <h4>{facilityInquiryRealLegalData?.result.name || '...'}</h4>
                      </td>
                      <td style={{ border: '1px solid #ddd', padding: '10px', textAlign: 'center' }}>
                        <h4>{inquiryDate || '...'}</h4>
                      </td>
                      <td style={{ border: '1px solid #ddd', padding: '10px', textAlign: 'center' }}>
                        <h4>{getFacilityTypeText(item?.facilityType || '')}</h4>
                      </td>
                      <td style={{ border: '1px solid #ddd', padding: '10px', textAlign: 'center' }}>
                        <h4>{item.facilityBranch.substring(0, 15)} ...</h4>
                      </td>
                      <td style={{ border: '1px solid #ddd', padding: '10px', textAlign: 'center' }}>
                        <h4>{`${item.facilitySetDate.slice(0, 4)}/${item.facilitySetDate.slice(
                          4,
                          6
                        )}/${item.facilitySetDate.slice(6, 8)}`}</h4>
                      </td>
                      <td style={{ border: '1px solid #ddd', padding: '10px', textAlign: 'center' }}>
                        <h4>{`${item.facilityEndDate.slice(0, 4)}/${item.facilityEndDate.slice(
                          4,
                          6
                        )}/${item.facilityEndDate.slice(6, 8)}`}</h4>
                      </td>
                      <td style={{ border: '1px solid #ddd', padding: '10px', textAlign: 'center' }}>
                        <h4>{formatPrice(Number(item.facilityAmountOrginal))} ریال</h4>
                      </td>
                      <td style={{ border: '1px solid #ddd', padding: '10px', textAlign: 'center' }}>
                        <h4>{formatPrice(Number(item.facilityDebtorTotalAmount || 0))} ریال</h4>
                      </td>
                      <td style={{ border: '1px solid #ddd', padding: '10px', textAlign: 'center' }}>
                        <h4>{formatPrice(Number(item.facilityDeferredAmount || 0))} ریال</h4>
                      </td>
                      <td style={{ border: '1px solid #ddd', padding: '10px', textAlign: 'center' }}>
                        <h4>{item.facilityRequestNo}</h4>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  )
}

export default FacilityPdfExport
